module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"potential_duplicate":"Potential Duplicate Living Donor","cancel":"Cancel","continue":"Continue"},"fr":{"potential_duplicate":"Double donneur vivant potentiel","cancel":"Annuler","continue":"Continuer"}}')
  delete Component.options._Ctor
}
